import Badge from '../../svgs/aboutUs/Badge'
import Briefcase from '../../svgs/aboutUs/Briefcase'
import Browser from '../../svgs/aboutUs/Browser'
import Creative from '../../svgs/aboutUs/Creative'
import Star from '../../svgs/aboutUs/Star'

const data = [
  {
    title: 'Efficienza',
    description:
      'Offriamo servizi rapidi e efficienti per far risparmiare tempo ai nostri clienti.',
    icon: <Badge style='h-24' />,
  },
  {
    title: 'Professionalità',
    description:
      "Il nostro team è composto da professionisti altamente qualificati e competenti nel campo dell'assistenza fiscale.",
    icon: <Briefcase style='h-24' />,
  },
  {
    title: 'Qualità',
    description:
      'La qualità dei nostri servizi è una priorità assoluta e ci impegniamo a garantire che ogni pratica venga elaborata con precisione e attenzione ai dettagli.',
    icon: <Star style='h-24' />,
  },
  {
    title: 'Accessibilità e inclusione',
    description:
      'Grazie alla nostra piattaforma online, i nostri servizi sono accessibili a tutti, eliminando la necessità di recarsi fisicamente presso un ufficio.',
    icon: <Browser style='h-24' />,
  },
  {
    title: 'Innovazione',
    description:
      "Utilizziamo la firma elettronica avanzata e adottiamo tecnologie innovative per migliorare costantemente l'esperienza del cliente.",
    icon: <Creative style='h-24' />,
  },
]

const AboutUsPoints = () => {
  return (
    <div className='pt-20 lg:pt-40 pb-30 lg:pb-60'>
      <div className='container mx-auto'>
        {data.map((ele, i) => (
          <div key={i} className='bg-green_100 rounded-xl p-24 mb-16 last:mb-0'>
            <div className='flex items-center gap-8 mb-16'>
              <div className='bg-green_150 rounded-xl min-w-[3rem] h-48 flex items-center justify-center'>
                {ele.icon}
              </div>
              <h3 className='text-2xl font-bold mb-0'>{ele.title}</h3>
            </div>
            <p className='text-dimmed text-xl leading-8 font-light mb-0'>
              {ele.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AboutUsPoints
